import { useState } from "react";
import { UserPlus } from "lucide-react";
import { PageInfoButton } from "@/components/common/page-info-button";
import { Button } from "@/components/ui/button";
import { usePageTitle } from "@/hooks/use-page-title";
import { useIsMobile } from "@/hooks/use-mobile";
import { InviteUserModal } from "@/components/admin/InviteUserModal";
import { InvitationList } from "@/components/admin/InvitationList";
import { UserList } from "@/components/admin/UserList";
import { AdminTabs } from "@/components/admin/AdminTabs";

export function AdminUsersPage() {
  usePageTitle("Users");
  const isMobile = useIsMobile();
  const [inviteModalOpen, setInviteModalOpen] = useState(false);

  return (
    <div className="pt-4 px-4 md:px-0">
      <div className="glass-card rounded-2xl p-4 md:p-6">
        <div className={`mb-6 flex ${isMobile ? "flex-col gap-3" : "items-center justify-between"}`}>
          <div className="flex items-center gap-1">
            <h1 className="text-lg font-medium">Admin</h1>
            <PageInfoButton title="Admin" />
          </div>
          <Button
            onClick={() => { setInviteModalOpen(true); }}
            className={isMobile ? "w-full" : ""}
          >
            <UserPlus className="mr-2 h-4 w-4" />
            Invite User
          </Button>
        </div>

        <AdminTabs />
        <UserList />

        <section className="mt-8">
          <h2 className="mb-4 text-base font-medium">Invitations</h2>
          <InvitationList />
        </section>

        <InviteUserModal
          open={inviteModalOpen}
          onClose={() => { setInviteModalOpen(false); }}
        />
      </div>
    </div>
  );
}
